import "./UwSubClass.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomButton, CustomLoadingButton } from "../../../components/ui/CustomButton";
import { showToast } from "../../../toastService";
import { getIconComponent } from "../../../utils/getIconComponent";
import newRequest from "../../../utils/newRequest";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Table,
  TableContainer,
  Paper,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Tooltip
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Select from "react-select";
import SaveIcon from "@mui/icons-material/Save";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { FiSearch, FiShield } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { SlArrowDown } from "react-icons/sl";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { MdAdd, MdClose, MdDelete, MdHome, MdSave } from "react-icons/md";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect";
import { qilloIconOptions } from "../../../utils/iconMapping";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import { qilloIconMap } from "../../../utils/iconMapping";
import { useTranslation } from "react-i18next";

const UwSubClass = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [addSmiDialog, setAddSmiDialog] = useState(false);
  const [classesWithSub, setClassesWithSub] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedSubClass, setSelectedSubClass] = useState({});
  const [subClassCovers, setSubClassCovers] = useState([]);
  const [selectedSubClassCover, setSelectedSubClassCover] = useState({});
  const [coverCategories, setCoverCategories] = useState([]);
  const [subClassCoverSmi, setSubClassCoverSmi] = useState([]);
  const [selectedCoverSmi, setSelectedCoverSmi] = useState({});
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [searchTermSmi, setSearchTermSmi] = useState("");
  const [filteredSmiData, setFilteredSmiData] = useState([]);
  // add class and sub class dialog
  const [addClassSubCode, setAddClassSubCode] = useState("");
  const [addClassSubName, setAddClassSubName] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const [scMcCode, setScMcCode] = useState("");
  const [scCode, setScCode] = useState("");
  const [scName, setScName] = useState("");
  const [scDesc, setScDesc] = useState("");

  const [scView, setScView] = useState(null);
  const [scEnabled, setScEnabled] = useState("Y");
  const [scMotor, setScMotor] = useState("");
  const [scAttributes, setScAttributes] = useState(null);
  const [scShowQty, setScShowQty] = useState("N");

  const [scShowBasis, setScShowBasis] = useState("N");
  const [scShowPerils, setScShowPerils] = useState("N");
  const [scShowBeneficiaries, setScShowBeneficiaries] = useState("N");
  const [scShowCharges, setScShowCharges] = useState("N");
  const [scShowExcess, setScShowExcess] = useState("N");
  const [scAllowAttachment, setScAllowAttachment] = useState("N");

  const [scIcon, setScIcon] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [scTreatyAllocation, setScTreatyAllocation] = useState(null);
  const [scImportTemplate, setScImportTemplate] = useState(null);
  const [selectedRiCategory, setSelectedRiCategory] = useState(null);
  const [riCategories, setRiCategories] = useState([]);
  const [dmvicCoverTypes, setDmvicCoverTypes] = useState([]);

  const [isCoverDialogOpened, setIsCoverDialogOpened] = useState(false);
  const [coverCode, setCoverCode] = useState(null);
  const [coverName, setCoverName] = useState(null);
  const [importEndpoints, setImportEndpoints] = useState([]);
  const [treatyTypes, setTreatyTypes] = useState([]);
  const [riAllocations, setRiAllocations] = useState([]);
  const [applicableViews, setApplicableViews] = useState([]);
  const [applicableAttributes, setApplicableAttributes] = useState([]);

  const fetchRiCategories = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "RI Categories" });
      const options = res.data.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setRiCategories(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchDmvicCoverTypes = async () => {
    try {
      const options = ["A_Single", "B_Single", "C_Single", "D_Single"].map((val) => ({
        value: val,
        label: val,
      }));
      setDmvicCoverTypes(options);
    } catch (error) {
      console.error("Error fetching dmvic cover types:", error);
    }
  };


  // new smi data
  const [formData, setFormData] = useState({
    smiCode: "",
    smiName: "",
    smiDesc: "",
    smiDefault: "Y",
    smiEnabled: "Y",
    smiRate: 0,
    smiRatePer: 100,
    smiFcl: 0,
  });

  const handleAddSmiInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value, });
  };

  const {
    smiCode,
    smiName,
    smiDesc,
    smiDefault,
    smiEnabled,
    smiRate,
    smiRatePer,
    smiFcl,
  } = formData;


  const endpoints = async () => {
    try {
      const options = [
        { value: "none", label: "None" },
        { value: "vehicles-template", label: "Vehicles" },
        { value: "fire-template", label: "Fire" },
        { value: "smi-template", label: "SMI" },
      ].map((vw) => ({
        value: vw?.value,
        label: vw?.label,
      }));
      setImportEndpoints(options);
    } catch (error) {
      console.error("Error setting endpoints :", error);
    }
  };


  const fetchTreatyTypes = async () => {
    try {
      const options = ["UW Year", "Clean Cut"].map((vw) => ({
        value: vw,
        label: vw,
      }));
      setTreatyTypes(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };


  const fetchRiAllocations = async () => {
    try {
      const options = ["Cover", "Top Location", "Risk Based", "None"].map((vw) => ({
        value: vw,
        label: vw,
      }));
      setRiAllocations(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };



  const setViews = async () => {
    try {
      const options = ["default", "fire", "engineering", "marine_cert", "medical", "motor", "bond"].map((vw) => ({
        value: vw,
        label: vw,
      }));

      setApplicableViews(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };


  const setAttributes = async () => {
    try {
      const options = [
        { code: "default" },
        { code: "Vehicle Attributes" },
        { code: "Person Attributes" },
        { code: "Building Attributes" },
        { code: "Machine Attributes" },
        { code: "Medical Attributes" },
        { code: "Weather Attributes" }].map((vw) => ({
          value: vw.code,
          label: vw.code,
        }));

      setApplicableAttributes(options);
    } catch (error) {
      console.error("Error fetching Occupations :", error);
    }
  };

  useEffect(() => {
    const filteredResults = classesWithSub.filter((item) => {
      const subClassMatches = item.subClasses.some(
        (subClass) =>
          subClass.sc_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
          subClass.sc_code?.toLowerCase().includes(searchTerm?.toLowerCase())
      );

      return subClassMatches;
    });

    setFilteredData(filteredResults);
  }, [classesWithSub, searchTerm]);

  const handleAddSmiSubmit = async () => {
    try {
      // Handle form submission here

      if (!smiName || smiName.trim() === "" || smiName.length === 0) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);

      await newRequest.post(
        "/uwSubClassCoverSmi/add",
        {
          smi_mc_code: selectedSubClassCover?.cc_mc_code,
          smi_sc_code: selectedSubClassCover?.cc_sc_code,
          smi_cc_code: selectedSubClassCover?.cc_code,
          smi_code: smiCode,
          smi_name: smiName,
          smi_desc: smiDesc || smiName,
          smi_rate: smiRate,
          smi_rate_per: smiRatePer,
          smi_fcl_value: smiFcl,
          smi_default: smiDefault,
          smi_enabled: smiEnabled,
          smi_add_to_si: "Y",
        }
      );
      setFormData({
        smiCode: "",
        smiName: "",
        smiDesc: "",
        smiDefault: "Y",
        smiEnabled: "Y",
        smiRate: 0,
        smiRatePer: 100,
        smiFcl: 0,
      });
      fetchSubClassCoverSmi(
        selectedSubClassCover?.cc_mc_code,
        selectedSubClassCover?.cc_sc_code,
        selectedSubClassCover?.cc_code
      );
      setIsProcessing(false);
      showToast(`SMI Added!`, "success");
    } catch (error) {
      setIsProcessing(false);
      console.log(error);
    }
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteSmi") {
        try {
          setIsProcessing(true);
          await newRequest.delete(`/uwSubClassCoverSmi/del/${objectToAction.object_id}`);
          fetchSubClassCoverSmi(
            selectedSubClassCover?.cc_mc_code,
            selectedSubClassCover?.cc_sc_code,
            selectedSubClassCover?.cc_code
          );
          setIsProcessing(false);
          showToast(`SMI Deleted!`, "success");
        } catch (error) {
          setIsProcessing(false);
          console.log(error);
        }
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setConfirmDialogOpen(false);
  };

  const fetchClassesWithSub = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.get("/uwClass/findWithSub");
      setClassesWithSub(res.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSubClassCovers = async (mcCode, scCode) => {
    try {
      const res = await newRequest.post("/uwSubClassCover/findAll", { cc_mc_code: mcCode, cc_sc_code: scCode, });
      if (res.data) {
        setSubClassCovers(res.data);
        setSelectedSubClassCover(res.data[0]);
        setCoverCategories([]);
        setCoverCategories(res.data[0]?.cc_categories);
        await fetchSubClassCoverSmi(
          res.data[0]?.cc_mc_code,
          res.data[0]?.cc_sc_code,
          res.data[0]?.cc_code
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSubClassCoverSmi = async (mcCode, scCode, ccCode) => {
    try {
      const res = await newRequest.post(
        "/uwSubClassCoverSmi/findAll",
        {
          smi_org_code: currentUser.usr_org_code,
          smi_mc_code: mcCode,
          smi_sc_code: scCode,
          smi_cc_code: ccCode,
        }
      );
      if (res.data) {
        setSubClassCoverSmi(res.data);
        setSelectedCoverSmi(res.data[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchClassesWithSub();
    setViews();
    setAttributes();
    fetchRiCategories();
    fetchTreatyTypes();
    fetchRiAllocations();
    endpoints();
    fetchDmvicCoverTypes();
  }, []);

  useEffect(() => {
    const filteredResults = classesWithSub.filter((item) => {
      const subClassMatches = item.subClasses.some(
        (subClass) =>
          subClass?.sc_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
          subClass?.sc_code?.toLowerCase().includes(searchTerm?.toLowerCase())
      );

      return subClassMatches;
    });

    setFilteredData(filteredResults);
  }, [classesWithSub, searchTerm]);


  const handleSmiChange = (value, rowId, field) => {
    setFilteredSmiData((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  useEffect(() => {
    const filteredSmiResults = subClassCoverSmi?.filter(
      (item) =>
        item.smi_code?.toLowerCase().includes(searchTermSmi?.toLowerCase()) ||
        item.smi_name?.toLowerCase().includes(searchTermSmi?.toLowerCase())
    );
    setFilteredSmiData(filteredSmiResults);
  }, [subClassCoverSmi, searchTermSmi]);

  const saveRecords = async (e) => {
    // e.preventDefault();
    try {

      // save sub class details
      await newRequest.put(`/uwSubClass/upd/${selectedSubClass._id}`,
        {
          sc_name: scName,
          sc_desc: scDesc,
          sc_icon: selectedIcon?.value,
          sc_enabled: scEnabled,
          sc_motor: scMotor,
          sc_view: scView?.value,
          sc_show_qty: scShowQty,
          sc_show_basis: scShowBasis,
          sc_show_perils: scShowPerils,
          sc_show_beneficiaries: scShowBeneficiaries,
          sc_show_charges: scShowCharges,
          sc_show_excess: scShowExcess,
          sc_allow_attachment: scAllowAttachment,
          sc_attributes: scAttributes?.value,
          sc_treaty_allocation: scTreatyAllocation?.value,
          sc_import_template: scImportTemplate?.value,
        }
      );


      // save changed smis
      const changedCovers = subClassCovers.filter((obj) => obj.changed_xx === "Y");

      // Loop through each object in the array
      for (let i = 0; i < changedCovers.length; i++) {
        // const obj = changedObjects[i];
        await newRequest.put(
          `/uwSubClassCover/upd/${changedCovers[i]._id}`,
          {
            cc_enabled: changedCovers[i].cc_enabled,
            cc_treaty_appl: changedCovers[i].cc_treaty_appl,
            cc_default: changedCovers[i].cc_default,
            cc_treaty_type: changedCovers[i].cc_treaty_type,
            cc_treaty_allocation: changedCovers[i].cc_treaty_allocation,
            cc_name: changedCovers[i].cc_name,
            cc_desc: changedCovers[i].cc_desc,
            cc_dmvic_issue: changedCovers[i].cc_dmvic_issue,
            cc_dmvic_code: changedCovers[i].cc_dmvic_code,
            cc_dmvic_cover: changedCovers[i].cc_dmvic_cover
          }
        );
      }


      // save changed smis
      const changedObjects = filteredSmiData.filter((obj) => obj.changed_xx === "Y");


      // Loop through each object in the array
      for (let i = 0; i < changedObjects.length; i++) {
        await newRequest.put(
          `/uwSubClassCoverSmi/upd/${changedObjects[i]._id}`,
          {
            smi_code: changedObjects[i].smi_code,
            smi_name: changedObjects[i].smi_name,
            smi_desc: changedObjects[i].smi_desc,
            smi_rate: changedObjects[i].smi_rate,
            smi_rate_per: changedObjects[i].smi_rate_per,
            smi_fcl_value: changedObjects[i].smi_fcl_value,
            smi_icon: changedObjects[i].smi_icon,
            smi_default: changedObjects[i].smi_default,
            smi_enabled: changedObjects[i].smi_enabled,
            smi_add_to_si: changedObjects[i].smi_add_to_si,
          }
        );
      }
      showToast("Updated!", "success");
    } catch (error) {
      console.log(error);
    }
  };


  const handleSubClassCoverChange = (value, rowId, field) => {
    setSubClassCovers((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleTreatyType = (rowId, field, selectedOption) => {
    try {
      const updatedItems = subClassCovers.map(item =>
        item._id === rowId ? { ...item, [field]: selectedOption ? selectedOption.value : "", changed_xx: "Y" } : item
      );
      setSubClassCovers(updatedItems);
    } catch (error) {
      console.log(error);
    }
  };


  const handleAddSubClass = async (selectedClass) => {
    try {
      if (!addClassSubName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!addClassSubCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      await newRequest.post("/uwSubClass/add", {
        sc_org_code: currentUser.usr_org_code,
        sc_mc_code: selectedClass.mc_code,
        sc_code: addClassSubCode,
        sc_name: addClassSubName,
        createdBy: currentUser.usr_id,
      });

      setAddClassSubName("");
      setAddClassSubCode("");
      fetchClassesWithSub();
      showToast("Sub Class Added!", "success");
    } catch (error) {
      showToast("Error Occured!", "error");
      setAddClassSubName("");
      setAddClassSubCode("");
      console.log(error);
    }
  };

  return (
    <div className="uw-sub-class">
      <div className="sub-class-left">
        {Object.keys(selectedSubClass).length === 0 && (
          <div className="no-sub-selected">
            <div className="no-sub-selected-wrapper">
              {Object.keys(selectedSubClass).length === 0 && (
                <h1 className="page-title">Please Select Sub Class to View Details</h1>
              )}
            </div>
          </div>
        )}
        {Object.keys(selectedSubClass).length > 0 && (
          <div className="sub-selected">
            <div className="sub-class-form">
              <div className="sub-class-navbar">
                <div className="sc-navbar-left">
                  <h1 className="page-title">{`${selectedSubClass.sc_code} ${selectedSubClass.sc_name}`}</h1>
                </div>
                <div className="sc-navbar-right">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#00D37F"
                    tooltip="Save changes"
                    endIcon={<MdSave />}
                    onClick={saveRecords}
                  >
                    {t('save')}
                  </CustomLoadingButton>
                </div>
              </div>
              <div className="sub-class-details">
                <div className="sub-class-details-left">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="scName"
                      className="form-dropdown-label"
                      style={{ width: "80px" }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="scName"
                      name="scName"
                      type="text"
                      placeholder="NAME"
                      value={scName}
                      className="form-input-item"
                      style={{ width: "350px" }}
                      onChange={(e) => setScName(e.target.value)}
                    />
                  </div>
                  <div style={{ display: "flex", paddingLeft: "80px", height: "40px", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <ToggleSwitch
                      id="scShowQty"
                      value={scShowQty}
                      onChange={setScShowQty}
                      label={t('showQuantity').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                      style={{ width: "max-content", }}
                    />
                    <ToggleSwitch
                      id="scMotor"
                      value={scMotor}
                      onChange={setScMotor}
                      label={t('motorProduct').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                      style={{ width: "max-content", }}
                    />
                  </div>
                  <div style={{ display: "flex", paddingLeft: "80px", height: "40px", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <ToggleSwitch
                      id="scEnabled"
                      value={scEnabled}
                      onChange={setScEnabled}
                      label={t('enabled').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                      style={{ width: "max-content", }}
                    />
                  </div>
                  <div style={{ display: "flex", paddingLeft: "80px", height: "40px", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <ToggleSwitch
                      id="scShowBasis"
                      value={scShowBasis}
                      onChange={setScShowBasis}
                      label={t('showBasisOfClaim').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                      style={{ width: "max-content", }}
                    />
                  </div>
                  <div style={{ display: "flex", paddingLeft: "80px", height: "40px", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <ToggleSwitch
                      id="scShowPerils"
                      value={scShowPerils}
                      onChange={setScShowPerils}
                      label={t('showPerils').toUpperCase()}
                      labelPosition="end"
                      labelWidth="max-content"
                      border="N"
                      style={{ width: "max-content", }}
                    />
                  </div>
                </div>

                <div className="sub-class-details-right">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="icon_select"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('icon').toUpperCase()}
                    </label>
                    <Select
                      id="icon_select"
                      name="icon_select"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      options={qilloIconOptions}
                      width="250px"
                      isSearchable={true}
                      placeholder={t('icon').toUpperCase()}
                      value={selectedIcon}
                      onChange={setSelectedIcon}
                      getOptionLabel={(e) => (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {e.icon} {e.label}
                        </div>
                      )}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="scView"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('view').toUpperCase()}
                    </label>
                    <Select
                      id="scView"
                      name="scView"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="250px"
                      value={scView}
                      onChange={(selectedOption) => setScView(selectedOption)}
                      options={applicableViews}
                      isSearchable={true}
                      placeholder={t('view').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="scAttributes"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('attributes').toUpperCase()}
                    </label>
                    <Select
                      id="scAttributes"
                      name="scAttributes"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="250px"
                      value={scAttributes}
                      onChange={(selectedOption) => setScAttributes(selectedOption)}
                      options={applicableAttributes}
                      isSearchable={true}
                      placeholder={t('attributes').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="sc_treaty_allocation"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('level').toUpperCase()}
                    </label>
                    <Select
                      id="sc_treaty_allocation"
                      name="sc_treaty_allocation"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="250px"
                      value={scTreatyAllocation}
                      onChange={(selectedOption) => setScTreatyAllocation(selectedOption)}
                      options={riAllocations}
                      isSearchable={true}
                      placeholder={t('level').toUpperCase()}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="sc_import_template"
                      className="form-dropdown-label"
                      style={{ width: "100px" }}
                    >
                      {t('template').toUpperCase()}
                    </label>
                    <Select
                      id="sc_import_template"
                      name="sc_import_template"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="250px"
                      value={scImportTemplate}
                      onChange={(selectedOption) => setScImportTemplate(selectedOption)}
                      options={importEndpoints}
                      isSearchable={true}
                      placeholder={t('template').toUpperCase()}
                    />
                  </div>
                </div>
              </div>
              <div className="form-grid-auto" style={{ height: "28px", paddingLeft: "90px", alignSelf: "flex-start", justifyContent: "space-between" }}>
                <ToggleSwitch
                  id="scShowBeneficiaries"
                  value={scShowBeneficiaries}
                  onChange={setScShowBeneficiaries}
                  label={t('showBeneficiaries').toUpperCase()}
                  labelPosition="end"
                  labelWidth="max-content"
                  border="N"
                  style={{ width: "max-content", }}
                />
                <ToggleSwitch
                  id="scShowCharges"
                  value={scShowCharges}
                  onChange={setScShowCharges}
                  label={t('showCharges').toUpperCase()}
                  labelPosition="start"
                  labelWidth="max-content"
                  border="N"
                  style={{ width: "max-content", }}
                />
              </div>
              <div className="form-grid-auto" style={{ height: "28px", paddingLeft: "90px", alignSelf: "flex-start", justifyContent: "space-between" }}>
                <ToggleSwitch
                  id="scAllowAttachment"
                  value={scAllowAttachment}
                  onChange={setScAllowAttachment}
                  label={t('allowAttachRisk').toUpperCase()}
                  labelPosition="end"
                  labelWidth="max-content"
                  border="N"
                  style={{ width: "max-content", }}
                />
                <ToggleSwitch
                  id="scShowExcess"
                  value={scShowExcess}
                  onChange={setScShowExcess}
                  label={t('showExcess').toUpperCase()}
                  labelPosition="start"
                  labelWidth="max-content"
                  border="N"
                  style={{ width: "max-content", }}
                />

              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="scDesc"
                  className="form-dropdown-label"
                  style={{ width: "100px", alignSelf: "flex-start" }}
                >
                  {t('description').toUpperCase()}
                </label>
                <textarea
                  id="scDesc"
                  name="scDesc"
                  type="text"
                  rows={3}
                  placeholder={t('description').toUpperCase()}
                  value={scDesc}
                  className="form-input-item"
                  style={{ width: "95%" }}
                  onChange={(e) => setScDesc(e.target.value)}
                />
              </div>
              <hr className="separator-h" />
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                <h1 className="main-title">{t('applicableCovers')}</h1>
                <CircularButton
                  currentTheme={currentTheme}
                  onClick={() => setIsCoverDialogOpened(true)}
                  icon={<MdAdd />}
                  width={"35px"}
                  height={"35px"} />
              </div>
              <div className="sub-class-cover-details">
                {subClassCovers.map((subClassCover) => (
                  <div
                    className={`${subClassCover._id === selectedSubClassCover._id
                      ? "single-sublass-cover active"
                      : "single-sublass-cover"
                      }`}
                    key={subClassCover._id}
                    onClick={async () => {
                      try {
                        setIsProcessing(true);
                        setSelectedSubClassCover(subClassCover);
                        setCoverCategories([]);
                        setCoverCategories(subClassCover?.cc_categories);
                        await fetchSubClassCoverSmi(
                          subClassCover?.cc_mc_code,
                          subClassCover?.cc_sc_code,
                          subClassCover?.cc_code
                        );
                        setIsProcessing(false);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    {/* <div className="single-sublass-cover-icon">
                      <MdHome size={24} />
                    </div> */}
                    <div className="single-sublass-cover-content">
                      <div
                        className="single-sublass-cover-title"
                        title={subClassCover?.cc_name}
                      >
                        <span className="name">{subClassCover?.cc_name}</span>
                        <span className="code">{subClassCover?.cc_code}</span>
                      </div>
                      <div className="single-sublass-cover-desc" style={{ width: "100%" }}>
                        {/* {subClassCover?.cc_desc} */}
                        <div className="input-item-with-label" style={{ width: "100%" }}>
                          <textarea
                            id="cc_desc"
                            name="cc_desc"
                            type="text"
                            rows={2}
                            placeholder={t('desc').toUpperCase()}
                            value={subClassCover?.cc_desc}
                            onChange={(e) => handleSubClassCoverChange(e.target.value, subClassCover?._id, "cc_desc")}
                            className="form-input-item"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>
                      {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                        <div style={{ display: "flex", flexDirection: "row", margin: "10px 0px", gap: "20px", alignItems: "center" }}>
                          <ToggleSwitch
                            value={subClassCover?.cc_default}
                            onChange={(newValue) => handleSubClassCoverChange(newValue, subClassCover?._id, "cc_default")}
                            label={t('default').toUpperCase()}
                            labelPosition="end"
                            labelWidth="max-content"
                            border="N"
                          />
                          <ToggleSwitch
                            value={subClassCover?.cc_dmvic_issue}
                            onChange={(newValue) => handleSubClassCoverChange(newValue, subClassCover?._id, "cc_dmvic_issue")}
                            label={t('dmvicApplicable').toUpperCase()}
                            labelPosition="end"
                            labelWidth="max-content"
                            border="N"
                          />
                          {subClassCover?.cc_dmvic_issue === "Y" &&
                            <div className="input-item-with-label">
                              <label
                                htmlFor="cc_dmvic_code"
                                className="form-dropdown-label"
                                style={{ width: "max-content" }}
                              >
                                {t('code').toUpperCase()}
                              </label>
                              <input
                                id="cc_dmvic_code"
                                name="cc_dmvic_code"
                                type="text"
                                placeholder={t('code').toUpperCase()}
                                value={subClassCover?.cc_dmvic_code}
                                onChange={(e) => handleSubClassCoverChange(e.target.value, subClassCover?._id, "cc_dmvic_code")}
                                className="form-input-item"
                                style={{ width: "100px" }}
                              />
                            </div>}
                          {subClassCover?.cc_dmvic_issue === "Y" &&
                            <div className="input-item-with-label">
                              <Select
                                id="cc_dmvic_cover"
                                name="cc_dmvic_cover"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="150px"
                                value={dmvicCoverTypes.find(option => option.value === subClassCover?.cc_dmvic_cover) || null}
                                onChange={(selectedOption) => handleSubClassCoverChange(selectedOption?.value, subClassCover?._id, "cc_dmvic_cover")}
                                options={dmvicCoverTypes}
                                placeholder={t('cover').toUpperCase()}
                              />
                            </div>}
                          {["insurance"].includes(currentUser?.token_org_type) &&
                            <ToggleSwitch
                              value={subClassCover?.cc_treaty_appl}
                              onChange={(newValue) => handleSubClassCoverChange(newValue, subClassCover?._id, "cc_treaty_appl")}
                              label={t('treatyApplicable').toUpperCase()}
                              labelPosition="end"
                              labelWidth="max-content"
                              border="N"
                            />}
                          {["insurance"].includes(currentUser?.token_org_type) &&
                            subClassCover?.cc_treaty_appl === "Y" &&
                            <div className="input-item-with-label" style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                              <Select
                                id="cc_treaty_type"
                                name="cc_treaty_type"
                                menuPortalTarget={document.body}
                                styles={{
                                  ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  })
                                }}
                                width="200px"
                                value={treatyTypes.find(option => option.value === subClassCover?.cc_treaty_type) || null}
                                onChange={selectedOption => handleTreatyType(subClassCover?._id, "cc_treaty_type", selectedOption)}
                                options={treatyTypes}
                                isSearchable={true}
                                placeholder={t('type').toUpperCase()}
                              />
                            </div>}
                        </div>}
                    </div>
                  </div>
                ))}
              </div>
              {/* applicable categories */}
              <hr className="separator-h" />
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", padding: "0px 5px" }}>
                <h1 className="main-title">{`${selectedSubClassCover?.cc_code} Categories`}</h1>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                  <div className="input-item-with-label">
                    {/* <label htmlFor="catg" style={{ width: "100px" }}>
                      {t('category').toUpperCase()}
                    </label> */}
                    <Select
                      id="catg"
                      name="catg"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="300px"
                      value={selectedRiCategory}
                      onChange={(selectedOption) => setSelectedRiCategory(selectedOption)}
                      options={riCategories}
                      isSearchable={true}
                      placeholder={t('category').toUpperCase()}
                    />
                  </div>
                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={async () => {
                      try {

                        if (!selectedRiCategory) {
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(`Please select category!`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }

                        const res = await newRequest.post("/uwSubClassCover/addCategory", { subclass_docid: selectedSubClassCover._id, ri_category: selectedRiCategory?.value });
                        if (res.data?.msg === "added") {
                          setCoverCategories((prev) => [...prev, res.data?.doc]);
                          showToast("Added!", "success");
                        } else if (res.data?.msg === "updated") {
                          showToast("Exists!", "success");
                        } else {
                          showToast("Error adding category!", "error");
                        }
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    icon={<MdAdd />} width={"35px"} height={"35px"} />
                </div>
              </div>
              <div className="chip-wrapper">
                {coverCategories?.map((cc) => (
                  <Tooltip
                    title={cc}
                    placement="left"
                  >
                    <Chip
                      key={cc}
                      label={cc}
                      className="chip"
                      onDelete={async () => {
                        try {
                          const res = await newRequest.post("/uwSubClassCover/removeCategory", { subclass_docid: selectedSubClassCover._id, ri_category: cc });
                          if (res.data?.msg === "removed") {
                            setCoverCategories((prev) => prev.filter(param => param !== cc));
                            showToast(`Removed!`, "success");
                          } else {
                            showToast(`error deleting record!`, "error");
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    />
                  </Tooltip>
                ))}
              </div>
              {/* end of applicable categories */}
              {/* cover smis */}
              <hr className="separator-h" />
              <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between", padding: "0px 5px" }}>
                <span className="main-title">{`${selectedSubClassCover?.cc_code} ${t('applicableSmis')}`}</span>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                  <div className="search-input-wrapper" style={{ width: "300px" }}>
                    <FiSearch className="search-input-icon" />
                    <input
                      className="search-input"
                      type="text"
                      placeholder={`${t('search')} ${t('smi')}`}
                      value={searchTermSmi}
                      onChange={(e) => setSearchTermSmi(e.target.value)}
                    />
                    {searchTermSmi.length > 0 && (
                      <MdClose
                        onClick={() => setSearchTermSmi("")}
                        className="search-input-icon"
                      />
                    )}
                  </div>

                  <CircularButton
                    currentTheme={currentTheme}
                    onClick={() => setAddSmiDialog(true)}
                    icon={<MdAdd />}
                    width={"35px"}
                    height={"35px"} />
                </div>
              </div>
              <div className="uw-smi-wrapper">
                <div className="sub-class-content">
                  {isLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                      />
                    </div>
                  ) : (
                    <div className="table-content">
                      {filteredSmiData?.length > 0 &&
                        <div className="table-content">
                          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                            className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                              <TableBody className="tablebody">
                                {filteredSmiData?.map((row, index) => (
                                  <TableRow
                                    key={row?._id}
                                    className={`${selectedCoverSmi?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                  >
                                    <TableCell className="table-cell center" style={{ maxWidth: "30px" }}>
                                      {index + 1}
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ width: "auto" }}>
                                      <div className="smi-data-wrapper" style={{ width: "100%" }}
                                        onClick={() => setSelectedCoverSmi(row)}>
                                        <div className="smi-data-col" style={{ flex: "1" }}>
                                          <div className="input-item-with-label">
                                            <label
                                              htmlFor="smi_code"
                                              className="form-dropdown-label"
                                              style={{ width: "60px" }}
                                            >
                                              {t('code').toUpperCase()}
                                            </label>
                                            <input
                                              id={`smi_code_${row?._id}`}
                                              name="smi_code"
                                              type="text"
                                              placeholder={t('code').toUpperCase()}
                                              className="form-input-item"
                                              style={{ width: "100px" }}
                                              value={row?.smi_code}
                                              onChange={(e) => handleSmiChange(e.target.value, row?._id, "smi_code")}
                                            />
                                          </div>
                                          <div className="input-item-with-label">
                                            <label
                                              htmlFor="smi_rate"
                                              className="form-dropdown-label"
                                              style={{ width: "60px", textAlign: "right" }}
                                            >
                                              {t('rate').toUpperCase()}
                                            </label>
                                            <input
                                              id={`smi_rate_${row?._id}`}
                                              name="smi_rate"
                                              type="number"
                                              placeholder={t('rate').toUpperCase()}
                                              className="form-input-item"
                                              style={{ width: "100px", textAlign: "right" }}
                                              value={row?.smi_rate}
                                              onChange={(e) => handleSmiChange(e.target.value, row?._id, "smi_rate")}
                                            />
                                          </div>
                                          <div className="input-item-with-label">
                                            <label
                                              htmlFor="smi_rate_per"
                                              className="form-dropdown-label"
                                              style={{ width: "60px" }}
                                            >
                                              {t('per').toUpperCase()}
                                            </label>
                                            <input
                                              id={`smi_rate_per_${row?._id}`}
                                              name="smi_rate_per"
                                              type="number"
                                              placeholder={t('per').toUpperCase()}
                                              className="form-input-item"
                                              style={{ width: "100px", textAlign: "right" }}
                                              value={row?.smi_rate_per}
                                              onChange={(e) => handleSmiChange(e.target.value, row?._id, "smi_rate_per")}
                                            />
                                          </div>
                                        </div>
                                        <div className="smi-data-col" style={{ flex: "3" }}>
                                          <div className="input-item-with-label" style={{ width: "98%" }}>
                                            <input
                                              id={`smi_name_${row?._id}`}
                                              name="smi_name"
                                              type="text"
                                              placeholder={t('name').toUpperCase()}
                                              className="form-input-item"
                                              style={{ width: "100%" }}
                                              value={row?.smi_name}
                                              onChange={(e) => handleSmiChange(e.target.value, row?._id, "smi_name")}
                                            />
                                          </div>
                                          <div className="input-item-with-label" style={{ width: "98%" }}>
                                            <textarea
                                              id={`smi_desc_${row?._id}`}
                                              name="smi_desc"
                                              type="text"
                                              rows={3}
                                              placeholder={t('desc').toUpperCase()}
                                              className="form-input-item"
                                              style={{ width: "100%" }}
                                              value={row?.smi_desc}
                                              onChange={(e) => handleSmiChange(e.target.value, row?._id, "smi_desc")}
                                            />
                                          </div>
                                        </div>
                                        <div className="smi-data-col" style={{ flex: "1", alignItems: "flex-end" }}>
                                          <div className="input-item-with-label" style={{ width: "100%" }}>
                                            <label
                                              htmlFor="smi_fcl_value"
                                              className="form-dropdown-label"
                                              style={{ width: "80px" }}
                                            >
                                              {t('fcl').toUpperCase()}
                                            </label>
                                            <input
                                              id={`smi_fcl_value_${row?._id}`}
                                              name="smi_fcl_value"
                                              type="number"
                                              placeholder="0.00"
                                              className="form-input-item"
                                              style={{ width: "100%", textAlign: "right" }}
                                              value={row?.smi_fcl_value}
                                              onChange={(e) => handleSmiChange(e.target.value, row?._id, "smi_fcl_value")}
                                            />
                                          </div>
                                          <ToggleSwitch
                                            id={`smi_default_${row?._id}`}
                                            value={row?.smi_default}
                                            onChange={(newValue) => handleSmiChange(newValue, row?._id, "smi_default")}
                                            label={t('default').toUpperCase()}
                                            labelPosition="start"
                                            labelWidth="max-content"
                                            border="N"
                                          />
                                          <ToggleSwitch
                                            id={`smi_enabled_${row?._id}`}
                                            value={row?.smi_enabled}
                                            onChange={(newValue) => handleSmiChange(newValue, row?._id, "smi_enabled")}
                                            label={t('enabled').toUpperCase()}
                                            labelPosition="start"
                                            labelWidth="max-content"
                                            border="N"
                                          />
                                          <ToggleSwitch
                                            id={`smi_add_to_si_${row?._id}`}
                                            value={row?.smi_add_to_si}
                                            onChange={(newValue) => handleSmiChange(newValue, row?._id, "smi_add_to_si")}
                                            label={t('addToSi').toUpperCase()}
                                            labelPosition="start"
                                            labelWidth="max-content"
                                            border="N"
                                          />
                                        </div>
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                      <CircularButton
                                        currentTheme={currentTheme}
                                        onClick={() => {
                                          try {
                                            let action_text = `Delete SMI ${row?.smi_name}?`;
                                            setObjectToAction({
                                              object_id: row?._id,
                                              action_text: action_text,
                                              new_doc_status: "delete",
                                            });
                                            setConfirmDialogAction("deleteSmi");
                                            setConfirmDialogOpen(true);
                                          } catch (error) {
                                            console.log(error);
                                          }
                                        }}
                                        color="#E53935" icon={<MdDelete />} width={"30px"} height={"30px"} />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="sub-class-right">
        <div className="homeSearch">
          <FiSearch className="homeSearchIcon" />
          <input
            className="homeSearchInput"
            type="text"
            placeholder={`${t('search')} ${t('subClass')}...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm?.length > 0 ? (
            <MdClose
              className="homeSearchClear"
              onClick={() => setSearchTerm("")}
            />
          ) : (
            <span className="homeSearchClearPlaceholder" />
          )}
        </div>
        <div className="sub-class-menu">
          <div className="class-details-wrapper">
            {filteredData?.map((singleClass) => (
              <div className="class-item"
                key={singleClass?._id}>
                <Accordion className="accordion">
                  <AccordionSummary
                    expandIcon={
                      <SlArrowDown
                        className="content-accordion-expand-icon"
                        style={{ color: "#f44336", fontWeight: "bold" }}
                      />
                    }
                    id="panel-header"
                  >
                    <Typography className="class-item-title">
                      <h1 className="sub-title">{singleClass.mc_name} [{singleClass.mc_code}]</h1>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="add-subclass-content">
                      <h1 className="sub-title soft">{t('addSubClass')}</h1>
                      <div className="input-item-with-label">
                        <input
                          id="scName"
                          name="scName"
                          type="text"
                          placeholder={t('name')}
                          value={addClassSubName}
                          className="form-input-item table"
                          onChange={(e) => setAddClassSubName(e.target.value)}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          gap: "5px",
                        }}
                      >
                        <div className="input-item-with-label">
                          <input
                            id="scCode"
                            name="scCode"
                            type="text"
                            placeholder={t('code')}
                            value={addClassSubCode}
                            className="form-input-item table"
                            style={{ width: "100%" }}
                            onChange={(e) => setAddClassSubCode(e.target.value)}
                          />
                        </div>
                        <CircularButton
                          currentTheme={currentTheme}
                          onClick={() => handleAddSubClass(singleClass)}
                          icon={<MdAdd />}
                          width={"30px"}
                          height={"30px"} />
                      </div>
                    </div>

                    {singleClass?.subClasses?.map((subClass) => (
                      <div
                        className={`${subClass?._id === selectedSubClass?._id
                          ? "single-sublass active"
                          : "single-sublass"
                          }`}
                        key={subClass?._id}
                        onClick={async () => {
                          try {
                            setIsProcessing(true);

                            setSelectedSubClass(subClass);

                            setScMcCode(subClass?.sc_mc_code);
                            setScCode(subClass?.sc_code);
                            setScName(subClass?.sc_name);
                            setScDesc(subClass?.sc_desc);
                            setScIcon(subClass?.sc_icon);
                            setScView({
                              value: subClass?.sc_view,
                              label: subClass?.sc_view
                            });
                            setScTreatyAllocation({
                              value: subClass?.sc_treaty_allocation,
                              label: subClass?.sc_treaty_allocation
                            });
                            setScEnabled(subClass?.sc_enabled);
                            setScMotor(subClass?.sc_motor);
                            setScAttributes({
                              value: subClass?.sc_attributes,
                              label: subClass?.sc_attributes
                            });
                            setScShowQty(subClass?.sc_show_qty);
                            setScShowBasis(subClass?.sc_show_basis);
                            setScShowPerils(subClass?.sc_show_perils);
                            setScShowBeneficiaries(subClass?.sc_show_beneficiaries);
                            setScShowCharges(subClass?.sc_show_charges);
                            setScShowExcess(subClass?.sc_show_excess);
                            setScAllowAttachment(subClass?.sc_allow_attachment);

                            setScImportTemplate({
                              value: subClass?.sc_import_template,
                              label: importEndpoints?.find(option => option?.value === subClass?.sc_import_template)?.label || ""
                            });

                            const IconComponent = qilloIconMap[subClass?.sc_icon] || MdHome;
                            setSelectedIcon({
                              value: subClass?.sc_icon,
                              label:
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <IconComponent className="icon" /> {subClass?.sc_icon}
                                </div>
                            });

                            await fetchSubClassCovers(
                              singleClass?.mc_code,
                              subClass?.sc_code
                            );
                            setIsProcessing(false);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        {/* <div className="single-sublass-icon">
                          <MdHome size={20} />
                        </div> */}
                        <div className="single-sublass-content">
                          <div
                            className="single-sublass-title"
                            title={subClass?.sc_name}
                          >
                            <span className="name">{subClass?.sc_name}</span>
                            <span className="code">{subClass?.sc_code}</span>
                          </div>
                          {/* <div className="single-sublass-desc">
                            {subClass.sc_desc}
                          </div> */}
                        </div>
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
          </div>
          <span style={{ height: "30px" }} />
        </div>
      </div>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {addSmiDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">ADD SMI</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setAddSmiDialog(false)}
                icon={<IoClose />}
                width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label htmlFor="smiName" style={{ width: "130px" }}>
                  {t('name').toUpperCase()}
                </label>
                <input
                  id="smiName"
                  name="smiName"
                  type="text"
                  placeholder={t('name').toUpperCase()}
                  value={smiName}
                  className="form-input-item"
                  style={{ width: "300px" }}
                  onChange={handleAddSmiInputChange}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="smiDesc"
                  style={{ width: "130px", alignSelf: "flex-start" }}
                >
                  {t('desc').toUpperCase()}
                </label>
                <textarea
                  id="smiDesc"
                  name="smiDesc"
                  type="text"
                  placeholder={t('desc').toUpperCase()}
                  value={smiDesc}
                  rows={5}
                  className="form-input-item"
                  style={{ width: "300px" }}
                  onChange={handleAddSmiInputChange}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="input-item-with-label">
                  <label htmlFor="smiRate" style={{ width: "130px" }}>
                    {t('rate').toUpperCase()}
                  </label>
                  <input
                    id="smiRate"
                    name="smiRate"
                    type="number"
                    placeholder="0.00"
                    value={smiRate}
                    className="form-input-item"
                    style={{ width: "100px", textAlign: "right" }}
                    onChange={handleAddSmiInputChange}
                  />
                </div>
                <div className="input-item-with-label">
                  <label htmlFor="smiRatePer" style={{ width: "95px" }}>
                    {t('ratePer').toUpperCase()}
                  </label>
                  <input
                    id="smiRatePer"
                    name="smiRatePer"
                    type="number"
                    placeholder="0.00"
                    value={smiRatePer}
                    className="form-input-item"
                    style={{ width: "100px", textAlign: "right" }}
                    onChange={handleAddSmiInputChange}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label htmlFor="smiFcl" style={{ width: "130px" }}>
                  {t('fcl').toUpperCase()}
                </label>
                <input
                  id="smiFcl"
                  name="smiFcl"
                  type="number"
                  placeholder={t('fcl').toUpperCase()}
                  value={smiFcl}
                  className="form-input-item"
                  style={{ width: "300px", textAlign: "right" }}
                  onChange={handleAddSmiInputChange}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="input-item-with-label">
                  <label htmlFor="smiDefault" style={{ width: "130px" }}>
                    {t('default').toUpperCase()}
                  </label>
                  <ToggleSwitch
                    id="smiDefault"
                    value={smiDefault}
                    onChange={handleAddSmiInputChange}
                    label=""
                    labelPosition="end"
                    labelWidth="max-content"
                    border="N"
                    style={{
                      width: "max-content",
                    }}
                  />
                </div>
                <div className="input-item-with-label">
                  <label htmlFor="smiEnabled" style={{ width: "95px" }}>
                    {t('enabled').toUpperCase()}
                  </label>
                  <ToggleSwitch
                    id="smiEnabled"
                    value={smiEnabled}
                    onChange={handleAddSmiInputChange}
                    label=""
                    labelPosition="end"
                    labelWidth="max-content"
                    border="N"
                    style={{
                      width: "max-content",
                    }}
                  />
                </div>
              </div>
              {/* <div className="input-item-with-label">
                <label htmlFor="smiCode" style={{ width: "130px" }}>
                  CODE
                </label>
                <input
                  id="smiCode"
                  name="smiCode"
                  type="text"
                  placeholder="CODE"
                  value={smiCode}
                  className="form-input-item"
                  style={{ width: "300px" }}
                  onChange={handleAddSmiInputChange}
                />
              </div> */}
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                endIcon={<MdAdd />}
                onClick={handleAddSmiSubmit}
                borderRadiusType="both"
                variant="tint"
                color="#0ea5a4"
                tooltip={`${t('add')} ${smiName}`}>
                {t('addSmi')}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}

      {isCoverDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('addCover').toUpperCase()}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setIsCoverDialogOpened(false)}
                icon={<MdClose />}
                width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label htmlFor="coverName" style={{ width: "130px" }}>
                  {t('name').toUpperCase()}
                </label>
                <input
                  id="coverName"
                  name="coverName"
                  type="text"
                  placeholder={t('name').toUpperCase()}
                  className="form-input-item"
                  value={coverName}
                  style={{ width: "300px" }}
                  onChange={(e) => setCoverName(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="coverCode" style={{ width: "130px" }}>
                  {t('code').toUpperCase()}
                </label>
                <input
                  id="coverCode"
                  name="coverCode"
                  type="text"
                  placeholder={t('code').toUpperCase()}
                  className="form-input-item"
                  value={coverCode}
                  style={{ width: "300px" }}
                  onChange={(e) => setCoverCode(e.target.value)}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                endIcon={<MdAdd />}
                onClick={async () => {
                  try {
                    if (!coverName) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(`Please enter name!`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }
                    if (!coverCode) {
                      setNotifyDialogTitle(t('note'));
                      setNotifyDialogText(`Please enter code!`);
                      setIsNotifyDialogOpen(true);
                      return;
                    }
                    setIsProcessing(true);

                    const res = await newRequest.post(
                      "/uwSubClassCover/add",
                      {
                        cc_mc_code: selectedSubClass.sc_mc_code,
                        cc_sc_code: selectedSubClass.sc_code,
                        cc_code: coverCode,
                        cc_name: coverName,
                        cc_desc: coverName
                      }
                    );
                    setIsProcessing(false);
                    if (res.data.msg === "exists") {
                      showToast(`Cover with CODE ${coverCode} already exists under ${selectedSubClass.sc_name}`, "error");
                    } else {
                      setSubClassCovers((prevData) => [...prevData, res.data?.doc]);
                      await fetchSubClassCoverSmi(
                        res.data?.cc_mc_code,
                        res.data?.cc_sc_code,
                        res.data?.cc_code
                      );
                      setIsCoverDialogOpened(false);
                      showToast(`Cover ${coverName} added`, "success");
                      setCoverCode(null);
                      setCoverName(null);
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}
                borderRadiusType="both"
                variant="tint"
                color="#0ea5a4"
                tooltip={`${t('add')} ${coverName}`}>
                {t('addCover')}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default UwSubClass;
